const deselectElementPreventDefaultAndBlur = (e: KeyboardEvent) : void => {
  if (e.target instanceof HTMLInputElement) {
    e.target.blur();
    e.preventDefault();
    e.stopImmediatePropagation();
  }
};

export default deselectElementPreventDefaultAndBlur;
